const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.hackernoon.com/a/events"
    : "http://localhost:5173/autumn/api/events";

export const logEvent = (category, action) => {
  fetch(`${API_URL}`, {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({type: "site", category, action}),
  }).catch(err => {});
};
